const useDefaultTableStyling = {
    actionsColumnIndex: -1,
    addRowPosition: "first",
    search: false,
    // Paginación (default central de las tablas):
    //  - pageSize / pageSizeOptions: valor inicial y opciones para el usuario.
    //  - emptyRowsWhenPaging: false evita que material-table rellene con filas
    //    vacías hasta completar la página. Ese relleno hacía la tabla muy alta
    //    al subir el tamaño de página y dejaba la vista "pegada" al control de
    //    paginación (abajo), ocultando los datos de arriba.
    pageSize: 10,
    pageSizeOptions: [10, 25, 50],
    emptyRowsWhenPaging: false,
    headerStyle: {
        backgroundColor: '#6e6e6e',
        color: '#FFF',
        paddingTop: 12,
        paddingBottom: 12
    },
    //paginationType: 'stepped'
}

export { useDefaultTableStyling }